import {
  POLIGRAPH_VISITCARD,
  POLIGRAPH_FLYER,
  POLIGRAPH_CALENDAR,
  POLIGRAPH_TAG,
  POLIGRAPH_STICKER,
  POLIGRAPH_HANGER,
  POLIGRAPH_ORACAL,
  POLIGRAPH_BANER,
  POLIGRAPH_PVC,
  POLIGRAPH_OTHER,
  POLIGRAPH_BUKLET,
  POLIGRAPH_PLAKAT,
  POLIGRAPH_BROSHURA,
  POLIGRAPH_CALENDAR3D,
  POLIGRAPH_BLANK,
  POLIGRAPH_MENU,
  POLIGRAPH_BLOKNOT,
  POLIGRAPH_CARDS,
  POLIGRAPH_LEAF,
  POLIGRAPH_KONVERT,
  POLIGRAPH_FOLDER
} from "../actionTypes";

export const PoligraphVisitcard = () => (dispatch) => {
  dispatch({ type: POLIGRAPH_VISITCARD });
};
export const PoligraphFlyer = () => (dispatch) => {
  dispatch({ type: POLIGRAPH_FLYER});
};
export const PoligraphCalendar = () => (dispatch) => {
  dispatch({ type: POLIGRAPH_CALENDAR });
};
export const PoligraphTag = () => (dispatch) => {
  dispatch({ type: POLIGRAPH_TAG });
};
export const PoligraphSticker = () => (dispatch) => {
  dispatch({ type: POLIGRAPH_STICKER });
};
export const PoligraphHanger = () => (dispatch) => {
  dispatch({ type: POLIGRAPH_HANGER });
};
export const PoligraphOracal = () => (dispatch) => {
  dispatch({ type: POLIGRAPH_ORACAL });
};
export const PoligraphBaner = () => (dispatch) => {
  dispatch({ type: POLIGRAPH_BANER });
};
export const PoligraphPvc = () => (dispatch) => {
  dispatch({ type: POLIGRAPH_PVC });
};
export const PoligraphOther = () => (dispatch) => {
  dispatch({ type: POLIGRAPH_OTHER });
};
export const PoligraphBuklet = () => (dispatch) => {
  dispatch({ type: POLIGRAPH_BUKLET });
};
export const PoligraphPlakat = () => (dispatch) => {
  dispatch({ type: POLIGRAPH_PLAKAT });
};
export const PoligraphBroshura = () => (dispatch) => {
  dispatch({ type: POLIGRAPH_BROSHURA });
};
export const PoligraphCalendar3d = () => (dispatch) => {
  dispatch({ type: POLIGRAPH_CALENDAR3D });
};
export const PoligraphBlank = () => (dispatch) => {
  dispatch({ type: POLIGRAPH_BLANK });
};
export const PoligraphMenu = () => (dispatch) => {
  dispatch({ type: POLIGRAPH_MENU });
};
export const PoligraphBloknot = () => (dispatch) => {
  dispatch({ type: POLIGRAPH_BLOKNOT });
};
export const PoligraphCards = () => (dispatch) => {
  dispatch({ type: POLIGRAPH_CARDS });
};
export const PoligraphLeaf = () => (dispatch) => {
  dispatch({ type: POLIGRAPH_LEAF });
};
export const PoligraphKonvert = () => (dispatch) => {
  dispatch({ type: POLIGRAPH_KONVERT });
};
export const PoligraphFolder = () => (dispatch) => {
  dispatch({ type: POLIGRAPH_FOLDER });
};

